import { monthCloseOutAlertConstants } from './constant';

const {
  GET_MONTH_CLOSE_OUT_ALERT_REQUEST,
  UPLOAD_MONTH_END_ALERT_SIGN_RESET,
  UPLOAD_MONTH_END_ALERT_SIGN_REQUEST,
} = monthCloseOutAlertConstants;

export const getMonthlyCloseOutAlert = (payload: any) => {
  return {
    type: GET_MONTH_CLOSE_OUT_ALERT_REQUEST,
    payload,
  };
};

export const uploadSignFileAction = (payload: any) => {
  return {
    type: UPLOAD_MONTH_END_ALERT_SIGN_REQUEST,
    payload,
  };
};

export const resetUploadSignFileAction = () => {
  return {
    type: UPLOAD_MONTH_END_ALERT_SIGN_RESET,
  };
};